import axios from "axios";
import Config from "src/config";

const BASE_URL = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/tarefas-config`;

// Workflows
export const actionListaWorkflows = (querys) => {
    return axios({ method: "get", url: `${BASE_URL}/workflows${querys}` });
};

export const actionCriarWorkflow = (data) => {
    return axios({ method: "post", url: `${BASE_URL}/workflows/criar`, data });
};

export const actionEditarWorkflow = (workflowId, data) => {
    return axios({ method: "put", url: `${BASE_URL}/workflows/${workflowId}/editar`, data });
};

export const actionReordenarWorkflows = (data) => {
    return axios({ method: "put", url: `${BASE_URL}/workflows/reordenar`, data });
};

export const actionDeletarWorkflow = (workflowId) => {
    return axios({ method: "delete", url: `${BASE_URL}/workflows/${workflowId}/deletar` });
};
